import { IconButton } from "@circleco/compass/components/IconButton";
import { Tooltip } from "@circleco/compass/components/Tooltip";

import { t } from "@/i18n-js/instance";
import { useCopyLinkToClipboard } from "@/react/hooks/useCopyLinkToClipboard";

interface CopyLinkIconButtonProps {
  getUrl: () => string;
}

export const CopyLinkIconButton = ({ getUrl }: CopyLinkIconButtonProps) => {
  const copyLinkToClipboard = useCopyLinkToClipboard();
  const label = t("ai_conversation.copy_link.label");

  return (
    <Tooltip content={label} side="bottom">
      <IconButton
        icon="chain-link"
        size="sm"
        variant="ghost"
        aria-label={label}
        onClick={() => copyLinkToClipboard(getUrl())}
      />
    </Tooltip>
  );
};
